import { observer } from "mobx-react-lite";
import { ClipboardList } from "lucide-react";
import { useTran } from "@/hooks";
import { PageHeader } from "@/components/common";
import { Can } from "@/hooks/useCan/Can";
import { useAuthStore } from "@/features/auth/hooks";

import {
  ActivityLogDetailsDialog,
  ActivityLogFilters,
  ActivityLogTable,
} from "../components";

const ActivityLogPage = observer(() => {
  const { t } = useTran();

  const { user } = useAuthStore();
  const permissions = user?.permissions || [];

  return (
    <div className="space-y-6">
      <PageHeader
        title={t("Activity Log")}
        description={t(
          "Review recent activity across users, modules, and dates.",
        )}
        icon={ClipboardList}
      />

      <Can
        resource="activity_log"
        showMessage={true}
        action="view"
        defaultView={true}
        userPermissions={permissions}
      >
        <div className="space-y-4 rounded-radius border border-border bg-card p-4">
          <ActivityLogFilters />
          <ActivityLogTable />
        </div>
      </Can>

      <ActivityLogDetailsDialog />
    </div>
  );
});

export default ActivityLogPage;
